export const inventoryConstants = {
  LOADING: "INV_LOADING",
  GET_ITEMS: "INV_GET_ITEMS",
  GET_ITEM_DETAILED: "INV_GET_ITEM_DETAILED",
  GET_MOVEMENTS: "INV_GET_MOVEMENTS",
  GET_STOCK_TAKES: "INV_GET_STOCK_TAKES",
  GET_STOCK_TAKE_DETAILED: "INV_GET_STOCK_TAKE_DETAILED",
  GET_LOW_STOCK: "INV_GET_LOW_STOCK",
  SCAN_RESULT: "INV_SCAN_RESULT",
  RESPONSE: "INV_RESPONSE",
};
